import { cn } from '@/lib/utils';

// ─── Base Skeleton ──────────────────────────────────────────────────────────
// Subtle pulse, no heavy shimmer. Matches final layout to avoid CLS.

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-muted/60 animate-skeleton rounded-md', className)}
      {...props}
    />
  );
}

// ─── Skeleton Text Line ─────────────────────────────────────────────────────
// Simulates a line of text with natural width variance.

function SkeletonText({
  lines = 1,
  className,
  ...props
}: React.ComponentProps<'div'> & { lines?: number }) {
  const widths = ['w-full', 'w-[85%]', 'w-[70%]', 'w-[60%]', 'w-[90%]', 'w-[75%]'];
  return (
    <div className={cn('space-y-2', className)} {...props}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={cn('h-3', widths[i % widths.length])} />
      ))}
    </div>
  );
}

// ─── Skeleton Circle ────────────────────────────────────────────────────────

function SkeletonCircle({
  size = 32,
  className,
  ...props
}: React.ComponentProps<'div'> & { size?: number }) {
  return (
    <Skeleton
      className={cn('shrink-0 rounded-full', className)}
      style={{ width: size, height: size }}
      {...props}
    />
  );
}

// ─── Skeleton Block ─────────────────────────────────────────────────────────
// Represents a card, panel, or content area placeholder.

function SkeletonBlock({ className, ...props }: React.ComponentProps<'div'>) {
  return <Skeleton className={cn('h-24 w-full rounded-lg', className)} {...props} />;
}

export { Skeleton, SkeletonText, SkeletonCircle, SkeletonBlock };
